import { NgModule } from '@angular/core';
import { BaseModule } from '@shared';
import { ReportsRoutingModule } from './reports-routing.module';
import { SharedDataModule } from '@shared-data';
import { ReportsComponent } from './reports.component';
import {
  AuditComponent,
  DeliveryExceptionsComponent,
  ExceptionsComponent,
  FailuresComponent,
  HistoryComponent,
  ModifierExceptionComponent,
  PricingExceptionsComponent,
  SubstitutionsExceptionComponent,
  SyncExceptionsComponent,
} from './components';
import { DatePipe } from '@angular/common';

@NgModule({
  declarations: [
    AuditComponent,
    HistoryComponent,
    ReportsComponent,
    FailuresComponent,
    ExceptionsComponent,
    DeliveryExceptionsComponent,
    PricingExceptionsComponent,
    ModifierExceptionComponent,
    SubstitutionsExceptionComponent,
    SyncExceptionsComponent,
  ],
  imports: [BaseModule, ReportsRoutingModule, SharedDataModule],
  exports: [ReportsComponent],
  providers: [DatePipe],
})
export class ReportsModule {}
